import * as React from 'react';

import { Button } from 'reactstrap';

type Props = {
  onFilesAdded: (files: FileList) => void,
  more: boolean, // True if we already have some photos
}
class FileInput extends React.Component<Props> {
  constructor(props) {
    super(props);
    this.fileFieldRef = React.createRef();
  }

  static defaultProps = {
    more: false,
  }

  render() {
    const buttonWording = this.props.more ? "Add more photos" : "Add photos";
    return (
      <div>
        <Button 
          color="primary"
          size="lg"
          block
          onClick={
            () => this.fileFieldRef.current.click()
          }>{buttonWording}</Button>

        <input type="file" 
          onChange={ e =>  this.props.onFilesAdded(e.target.files)}
          name="photo[image]"
          multiple={true}
          className="invisible d-none"
          ref={this.fileFieldRef}
          accept="image/jpeg,image/jpg" />
      </div>
    );
  }
}
export default FileInput;
